import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/Home.vue';
import { login, getEmailDomain, msalInstance } from '../auth/authService';
 
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: async (to, from) => {
      const account = await login();
      if (account) {
        const emailDomain = getEmailDomain(account);
        if (emailDomain === 'crgl-thirdparty.com') {
          window.location.replace('https://degreed.com/?orgsso=cargill');
          //next({ name: 'http://myhrinfo.cargill.com/' })
        } else {
          window.location.replace('https://degreed.com/?orgsso=cargill');
          //next({ name: 'https://degreed.com/?orgsso=cargill' })
        }
      }
    },
  },
];
 
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
 
export default router;
